import React from 'react';

/**
 * Renders `fallback` instead of its children when they throw: a texture that
 * fails to load (dead link, blocked by the browser) then shows a plain
 * surface rather than taking the whole canvas down with it.
 */
export class FallbackOnError extends React.Component<{ fallback: React.ReactNode; children: React.ReactNode; what?: string }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error) { console.warn(`[scene] ${this.props.what || 'texture'} could not load, using a plain material:`, error.message); }
  render() { return this.state.failed ? this.props.fallback : this.props.children; }
}
